import { IncentiveCampaignsListResponse } from '../../@types';

export function incentiveCampaignsList(payload: IncentiveCampaignsListResponse) {
  return payload;
}
